import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { useAddRegionalMutation } from "@/services/regional";
import { toast } from "components/ui/use-toast";
import { MESSAGES } from "./messages";
import { AddMultipleRegionalContent } from "./add-multiple-regional-content";

export function useAddMultipleRegionalModal() {
  const { handleModal } = useDialogModal();
  const [addRegional] = useAddRegionalMutation();

  const openAddMultipleRegionalModal = () => {
    handleModal({
      isOpen: true,
      title: "Adicionar Regionais",
      description:
        "Digite o nome de uma regional e pressione Enter para adicioná-la à lista.",
      element: (
        <AddMultipleRegionalContent
          onConfirm={async (items) => {
            try {
              await addRegional(items).unwrap();
              handleModal({ isOpen: false });
              toast(MESSAGES.CREATE.SUCCESS);
            } catch (error) {
              console.error(error);
              toast(MESSAGES.CREATE.ERROR);
            }
          }}
          onCancel={() => handleModal({ isOpen: false })}
        />
      ),
    });
  };

  return { openAddMultipleRegionalModal };
}